import React, { Component } from "react";
import { PageHeader } from "antd";
import TabbedDynamicTable from "../../../Components/TabbedDynamicTable";
import InsumosConfiguracion from "./InsumosConfiguracion/InsumosConfiguracion";
import ContabilidadConfiguracion from "./ContabilidadConfiguracion/ContabilidadConfiguracion";
import FiscalConfiguracion from "./FiscalConfiguracion/FiscalConfiguracion";
import GeneralConfiguracion from "./GeneralConfiguracion/GeneralConfiguracion";
import AvanzadoConfiguracion from "./AvanzadoConfiguracion/AvanzadoConfiguracion";
// DescargaMasivaConfiguracion ahora se renderiza dentro de FiscalConfiguracion
import ComplementosPlan from "./ComplementosPlan/ComplementosPlan";
import {
  AppstoreAddOutlined,
  SafetyCertificateOutlined,
  BankOutlined,
  HomeFilled,
  ShopFilled,
  SettingFilled,
  TruckOutlined,
  ApiOutlined,
  MailOutlined,
  FileTextOutlined,
  ThunderboltOutlined,
  DollarOutlined
} from "@ant-design/icons";
import LogisticaConfiguracion from "./LogisticaConfiguracion/LogisticaConfiguracion";
import ComplementosConfiguracion from "./ComplementosConfiguracion/ComplementosConfiguracion";
import CorreoConfiguracion from "./CorreoConfiguracion/CorreoConfiguracion";
import SeriesFoliosConfiguracion from "./SeriesFoliosConfiguracion.js/SeriesFoliosConfiguracion";
import { IconPowerBi } from "../../../Icons/Icons";
import PowerBiConfiguracion from "./PowerBiConfiguracion/PowerBiConfiguracion";
import AutomatizacionConfiguracion from "./AutomatizacionConfiguracion/AutomatizacionConfiguracion";
import MonedasConfiguracion from "./MonedasConfiguracion/MonedasConfiguracion";
// import TimbradoConfiguracion from "./TimbradoConfiguracion/TimbradoConfiguracion";

class Configuracion extends Component {
  state = { versionPreferencias: 0 };

  render() {

    const tabItems = [
      {
        label: (
          <span>
            <HomeFilled />
            General
          </span>
        ),
        key: "1",
        children: <GeneralConfiguracion/>
      },
      // {
      //   label: (
      //     <span>
      //       <EnvironmentOutlined />
      //       Direccion
      //     </span>
      //   ),
      //   key: "4",
      //   children: <DireccionConfiguracion/>
      // },
      // {
      //   label: (
      //     <span>
      //       <NumberOutlined />
      //       Numeracion
      //     </span>
      //   ),
      //   key: "8",
      //   children: <NumeracionConfiguracion/>
      // },
      {
        label: (
          <span>
            <BankOutlined />
            Contabilidad
          </span>
        ),
        key: "2",
        children: <ContabilidadConfiguracion/>
      },
      {
        label: (
          <span>
            <DollarOutlined />
            Monedas
          </span>
        ),
        key: "17",
        children: <MonedasConfiguracion/>
      },
      {
        label: (
          <span>
            <FileTextOutlined/>
            Series y Folios
          </span>
        ),
        key: "15",  // único, no repetido
        children: <SeriesFoliosConfiguracion />
      },
      // {
      //   label: (
      //     <span>
      //       <RocketOutlined />
      //       Envio
      //     </span>
      //   ),
      //   key: "10",
      //   children: <EnvioConfiguracion/>
      // },
      {
        label: (
          <span>
            <SafetyCertificateOutlined />
            Llave SAT
          </span>
        ),
        key: "6",
        children: <FiscalConfiguracion/>
      },

      {
        label: (
          <span>
            <ShopFilled />
            Insumos
          </span>
        ),
        key: "3",
        children: <InsumosConfiguracion/>
      },
      // {
      //   label: (
      //     <span>
      //       <BarcodeOutlined />
      //       Detallista
      //     </span>
      //   ),
      //   key: "11",
      //   children: <ComplementoDetallistaConfiguracion/>
      // },
      {
        label: (
          <span>
            <AppstoreAddOutlined />
            Complementos
          </span>
        ),
        key: "18",
        children: <ComplementosPlan onCambio={() => this.setState((s) => ({ versionPreferencias: s.versionPreferencias + 1 }))} />
      },
      {
        label: (
          <span>
            <ApiOutlined />
            Preferencias del sistema
          </span>
        ),
        key: "11",
        children: <ComplementosConfiguracion key={this.state.versionPreferencias} />
      },

      {
        label: (
          <span>
            <TruckOutlined />
            Logistica
          </span>
        ),
        key: "12",
        children: <LogisticaConfiguracion/>
      },
      {
        label: (
          <span>
            <SettingFilled />
            Avanzado
          </span>
        ),
        key: "5",
        children: <AvanzadoConfiguracion/>
      },
      {
        label: (
          <span>
            <MailOutlined />
            Correo
          </span>
        ),
        key: "13",
        children: <CorreoConfiguracion/>
      },
      {
        label: (
          <span>
            <ThunderboltOutlined />
            Automatización
          </span>
        ),
        key: "16",
        children: <AutomatizacionConfiguracion/>
      },
      {
        label: (
          <span>
            <IconPowerBi />
            Configuracion PowerBi
          </span>
        ),
        key: "14",
        disabled: true,
        children: <PowerBiConfiguracion/>
      },
    ]

    const tabs = tabItems.map(({ children, ...item }) => ({
      ...item,
      customContent: children,
    }));

    return (
      <>
        <PageHeader
          title="Configuracion"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div style={{backgroundColor: 'white', padding: 20,paddingTop: 14}}>
          <TabbedDynamicTable tabs={tabs} showContentBorder={false} defaultActiveKey="1" />
        </div>
      </>
    );
  }
}

export default Configuracion;
